<template>
  <div class="normal-menu">
    <div class="menu-item" :style="{paddingLeft: step * 20 + 'px'}"
         :class="{'active': menu.isChecked, 'font-bold': menu.children && menu.children.length}">
      <i class="el-icon-arrow-down mr-5" :class="{'is-open' : isOpen}" v-if="menu.children && menu.children.length"></i>
      <div class="text-left cursor" :class="notFlex ? 'mr-20' : 'flex-1'" @click="setOpen">
        {{menu.name}}
      </div>
      <el-checkbox :class="{'cb-16-f5971d' : type === 1}" v-model="menuData.isChecked" @change="onChange"></el-checkbox>
    </div>
    <template v-if="menu.children && menu.children.length && isOpen">
      <normal-menu :step="step + 1" v-for="(child, idx) in menu.children" :index="idx" :not-flex="notFlex" :key="idx" :type="type" @on-checked="onChangeRadio" :menu-data="child"></normal-menu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NormalMenu',
  components: {},
  // type 0：checkbox，1：radio
  props: ['menuData', 'type', 'step', 'index', 'notFlex'],
  watch: {
    menuData (newVal, oldVal) {
      this.menu = newVal
      this.isOpen = true
    }
  },
  data () {
    return {
      isOpen: true,
      menu: this.menuData
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    setOpen () {
      this.isOpen = !this.isOpen
    },
    onChange (val) {
      this.$emit('on-checked', val, this.index, this.menu)
    },
    onChangeRadio (val, index, menu) {
      this.$emit('on-checked', val, index, menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.normal-menu {
  &> .menu-item {
    display: flex;
    align-items: center;
    height: 35px;
    font-size: 12px;
    line-height: 35px;
    .el-icon-arrow-down {
      font-size: 14px;
      color: #30313a;
      transition: transform .3s;
      margin-bottom: 2px;
      font-weight: bold;
    }
    &.active {
      color: #f5971d;
      .el-icon-arrow-down {
        color: #f5971d;
      }
    }
    .is-open {
      &.el-icon-arrow-down {
        transform: rotate(180deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NormalMenu.vue